import {MapProvider} from "../../../contexts/MapContext"
import {AdminProvider} from "../../../contexts/AdminContext"
import HomeMap from "@/components/elements/Map";
export default function HomeReglementation() {
  
  return (
    <MapProvider>
      <AdminProvider>
        <HomeMap></HomeMap>
      </AdminProvider>
    </MapProvider>
  );
}
